import { notFound } from "@tanstack/react-router";

import { ApiError } from "../../lib/api";

/** A loader's request, with the API's 404 and malformed-parameter 400 turned into a real 404 page. */
export const orNotFound = async <T>(request: () => Promise<T>): Promise<T> => {
  try {
    return await request();
  } catch (error) {
    if (error instanceof ApiError && (error.status === 404 || error.status === 400)) {
      throw notFound();
    }
    throw error;
  }
};
